import { TranslatorService } from 'src/core/translator/domain/translator-service';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { LanguageService } from 'src/core/language/domain/language.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AngularTranslatorService implements TranslatorService {
  private preferredLanguage!: string;
  currentLanguage!: string;

  constructor(private readonly translateService: TranslateService) {}

  async init() {
    this.preferredLanguage = this.getPreferredLanguage();
    this.currentLanguage = this.preferredLanguage;
  }

  translate(key: string, params?: object): string {
    return this.translateService.instant(key, params);
  }

  private isSupportedLanguage(languageCode: string): boolean {
    return LanguageService.activeLanguages().some((lang) => lang.id === languageCode);
  }

  async changeLanguage(languageCode: string): Promise<void> {
    await firstValueFrom(this.translateService.use(languageCode));
    this.currentLanguage = languageCode;
  }

  getPreferredLanguage(): string {
    const browserLang = this.translateService.getBrowserLang()?.toLowerCase() ?? null;
    if (!browserLang) {
      return LanguageService.DEFAULT_LANGUAGE;
    }

    // if browser lang is not one of the available languages, return default one
    if (!this.isSupportedLanguage(browserLang)) {
      return LanguageService.DEFAULT_LANGUAGE;
    }

    return browserLang;
  }
}
